import Tr from 'translations/Translations';

export const OfferChoiceResultFileState = {
    NEW: "NEW",
    PUBLISHED: "PUBLISHED",
    WITHDRAWN: "WITHDRAWN"
}
const _TR_PREFIX = 'offer_choice_result_file_state_';

export const OfferChoiceResultFileStateLabel = (status) => (Tr(_TR_PREFIX + status.toLowerCase()));
